import React, { useState } from "react";
import NewCommonServiceContent from "../../../common/NewCommonServices/NewCommonServiceContent";
import ServiceButton from "../../../common/ServiceButton";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import logo1 from "../../../../assets/images/serviceImages/logo1.webp";
import logo2 from "../../../../assets/images/serviceImages/logo2.webp";
import logo3 from "../../../../assets/images/serviceImages/logo3.webp";
import logo4 from "../../../../assets/images/serviceImages/logo4.webp";
import logo5 from "../../../../assets/images/serviceImages/logo5.webp";
import logo6 from "../../../../assets/images/serviceImages/logo6.webp";
import socialMedia1 from "../../../../assets/images/serviceImages/socialMedia1.webp";
import socialMedia2 from "../../../../assets/images/serviceImages/socialMedia2.webp";
import socialMedia3 from "../../../../assets/images/serviceImages/socialMedia3.webp";
import socialMedia4 from "../../../../assets/images/serviceImages/socialMedia4.webp";
import socialMedia5 from "../../../../assets/images/serviceImages/socialMedia5.webp";

type ButtonType = "logo design" | "social Media";

const BrandingWork = () => {
  const [selectedButton, setSelectedButton] =
    useState<ButtonType>("logo design");

  return (
    <div>
      <NewCommonServiceContent>
        <div>
          <div className="flex justify-center gap-10 mb-5 sm:mb-10">
            <ServiceButton
              className={`${
                selectedButton === "logo design" ? "!card-gradient" : ""
              } text-white`}
              onClick={() => setSelectedButton("logo design")}
            >
              Logo Design
            </ServiceButton>
            <ServiceButton
              className={`${
                selectedButton === "social Media" ? "!card-gradient" : ""
              } text-white`}
              onClick={() => setSelectedButton("social Media")}
            >
              Social Media
            </ServiceButton>
          </div>
          <div>
            {selectedButton === "logo design" && (
              <div className="text-white">
                <Swiper
                  modules={[Navigation, Pagination, Autoplay]}
                  className="flex justify-center items-center"
                  pagination={{
                    type: "bullets",
                    el: ".pagination-progress",
                    clickable: true,
                  }}
                  autoplay={true}
                  spaceBetween={20}
                  slidesPerView={1}
                  navigation={{
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                  }}
                  loop
                >
                  <SwiperSlide className="rounded-[16px]">
                    <>
                      <div className="hidden lg:grid lg:grid-cols-4 gap-10">
                        <img
                          src={logo1}
                          className="rounded-[30px] lg:row-span-2 w-full"
                          alt=""
                        />
                        <img
                          src={logo2}
                          className="rounded-[30px] w-full"
                          alt=""
                        />
                        <img
                          src={logo3}
                          className="rounded-[30px] w-full"
                          alt=""
                        />
                        <img
                          src={logo6}
                          className="rounded-[30px] lg:row-span-2 w-full"
                          alt=""
                        />
                        <img
                          src={logo4}
                          className="rounded-[30px] w-full"
                          alt=""
                        />
                        <img
                          src={logo5}
                          className="rounded-[30px] w-full"
                          alt=""
                        />
                      </div>
                      <div className="lg:hidden">
                        <Swiper
                          modules={[Navigation, Pagination, Autoplay]}
                          className="flex justify-center items-center"
                          pagination={{
                            type: "bullets",
                            el: ".pagination-progress",
                            clickable: true,
                          }}
                          autoplay={true}
                          spaceBetween={20}
                          slidesPerView={1}
                          navigation={{
                            nextEl: ".swiper-button-next",
                            prevEl: ".swiper-button-prev",
                          }}
                          loop
                        >
                          <SwiperSlide>
                            <img
                              src={logo1}
                              className="rounded-[30px] h-[250px] object-cover w-full"
                              alt=""
                            />
                          </SwiperSlide>
                          <SwiperSlide>
                            <img
                              src={logo2}
                              className="rounded-[30px] h-[250px] object-cover w-full"
                              alt=""
                            />
                          </SwiperSlide>
                          <SwiperSlide>
                            <img
                              src={logo3}
                              className="rounded-[30px] h-[250px] object-cover w-full"
                              alt=""
                            />
                          </SwiperSlide>
                          <SwiperSlide>
                            <img
                              src={logo4}
                              className="rounded-[30px] h-[250px] object-cover w-full"
                              alt=""
                            />
                          </SwiperSlide>
                          <SwiperSlide>
                            <img
                              src={logo5}
                              className="rounded-[30px] h-[250px] object-cover w-full"
                              alt=""
                            />
                          </SwiperSlide>
                          <SwiperSlide>
                            <img
                              src={logo6}
                              className="rounded-[30px] h-[250px] object-cover w-full"
                              alt=""
                            />
                          </SwiperSlide>
                        </Swiper>
                        <div className="swiper-pagination pagination-progress w-full relative z-10"></div>
                      </div>
                    </>
                  </SwiperSlide>
                </Swiper>
              </div>
            )}
            {selectedButton === "social Media" && (
              <div className="text-white">
                <Swiper
                  modules={[Navigation, Pagination, Autoplay]}
                  className="flex justify-center items-center"
                  pagination={{
                    type: "bullets",
                    el: ".pagination-progress",
                    clickable: true,
                  }}
                  autoplay={true}
                  spaceBetween={20}
                  slidesPerView={1}
                  navigation={{
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                  }}
                  loop
                >
                  <SwiperSlide className="rounded-[16px]">
                    <>
                      <div className="hidden lg:grid lg:grid-cols-4 gap-10">
                        <img
                          src={socialMedia1}
                          className="rounded-[30px] w-full"
                          alt=""
                        />
                        <img
                          src={socialMedia2}
                          className="rounded-[30px] w-full"
                          alt=""
                        />
                        <img
                          src={socialMedia3}
                          className="rounded-[30px] w-full h-full lg:col-span-2 lg:row-span-2"
                          alt=""
                        />
                        <img
                          src={socialMedia4}
                          className="rounded-[30px] w-full"
                          alt=""
                        />
                        <img
                          src={socialMedia5}
                          className="rounded-[30px] w-full"
                          alt=""
                        />
                      </div>
                      <div className="lg:hidden">
                        <Swiper
                          modules={[Navigation, Pagination, Autoplay]}
                          className="flex justify-center items-center"
                          pagination={{
                            type: "bullets",
                            el: ".pagination-progress",
                            clickable: true,
                          }}
                          autoplay={true}
                          spaceBetween={20}
                          slidesPerView={1}
                          navigation={{
                            nextEl: ".swiper-button-next",
                            prevEl: ".swiper-button-prev",
                          }}
                          loop
                        >
                          <SwiperSlide>
                            <img
                              src={socialMedia1}
                              className="rounded-[30px] h-[250px] object-cover w-full"
                              alt=""
                            />
                          </SwiperSlide>
                          <SwiperSlide>
                            <img
                              src={socialMedia2}
                              className="rounded-[30px] h-[250px] object-cover w-full"
                              alt=""
                            />
                          </SwiperSlide>
                          <SwiperSlide>
                            <img
                              src={socialMedia3}
                              className="rounded-[30px] h-[250px] object-cover w-full"
                              alt=""
                            />
                          </SwiperSlide>
                          <SwiperSlide>
                            <img
                              src={socialMedia4}
                              className="rounded-[30px] h-[250px] object-cover w-full"
                              alt=""
                            />
                          </SwiperSlide>
                          <SwiperSlide>
                            <img
                              src={socialMedia5}
                              className="rounded-[30px] h-[250px] object-cover w-full"
                              alt=""
                            />
                          </SwiperSlide>
                        </Swiper>
                        <div className="swiper-pagination pagination-progress w-full relative z-10"></div>
                      </div>
                    </>
                  </SwiperSlide>
                </Swiper>
              </div>
            )}
          </div>
        </div>
      </NewCommonServiceContent>
    </div>
  );
};

export default BrandingWork;
